<template>
  <div class="container">
    <div v-if="!$deviceState.isMobile">
      <div class="df-ac-jsb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>系统管理</el-breadcrumb-item>
          <el-breadcrumb-item>用户管理</el-breadcrumb-item>
        </el-breadcrumb>
        <el-button class="newBudget" type="primary" @click="createAccount">
          创建用户
        </el-button>
      </div>

      <el-card class="box-card set-scroll">
        <el-table
          :data="tableData"
          style="width: 100%"
          @row-click="clickControl"
        >
          <el-table-column label="序号" width="auto">
            <template slot-scope="scope">
              {{
                scope.$index + 1 + (pageData.pageNum - 1) * pageData.pageSize
              }}
            </template>
          </el-table-column>

          <el-table-column
            prop="userName"
            label="用户名"
            width="auto"
          ></el-table-column>
          <!-- <el-table-column
          prop="passWord"
          label="密码"
          min-width="100%"
        ></el-table-column> -->

          <el-table-column prop="create_Time" label="创建时间" width="auto">
          </el-table-column>

          <el-table-column fixed="right" label="操作" width="100">
            <template slot-scope="scope">
              <el-button
                icon="el-icon-edit"
                @click.stop="changePassword(scope.row)"
                type="text"
                size="small"
                >修改密码
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageData.pageNum"
          :page-sizes="[100, 200, 300, 400]"
          :page-size="pageData.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalPage"
        >
        </el-pagination>
      </el-card>

      <!-- 创建用户弹框 -->
      <el-dialog
        append-to-body
        :title="dialogTitle"
        :visible.sync="dialogVisible"
        width="30%"
        :before-close="handleClose"
      >
        <el-form :model="createAccountForm" ref="createAccountForm">
          <el-form-item
            label="用户名称："
            label-width="6.25rem"
            required
            :rules="[
              { required: true, message: '请输入用户名称', trigger: 'blur' }
            ]"
            prop="userName"
          >
            <el-input
              placeholder="请输入用户名称"
              v-model="createAccountForm.userName"
            ></el-input>
          </el-form-item>

          <el-form-item
            label="用户密码："
            label-width="6.25rem"
            required
            :rules="[
              { required: true, message: '请输入用户密码', trigger: 'blur' }
            ]"
            prop="passWord"
          >
            <el-input
              placeholder="请输入用户密码"
              v-model="createAccountForm.passWord"
            ></el-input>
          </el-form-item>
        </el-form>

        <!--  -->
        <span slot="footer" class="dialog-footer">
          <el-button @click="colseDialog">取 消</el-button>
          <el-button type="primary" @click="confirmDialog">确 定</el-button>
        </span>
      </el-dialog>

      <!-- 修改密码弹框 -->
      <el-dialog
        append-to-body
        title="修改密码"
        :visible.sync="changePwDialogVisible"
        width="30%"
        :before-close="changePwHandleClose"
      >
        <el-form :model="changePwForm" ref="changePwForm">
          <el-form-item
            label="用户名称："
            label-width="6.25rem"
            required
            :rules="[
              { required: true, message: '请输入用户名称', trigger: 'blur' }
            ]"
            prop="userName"
          >
            <el-input
              disabled
              placeholder="请输入用户名称"
              v-model="changePwForm.userName"
            ></el-input>
          </el-form-item>

          <el-form-item
            label="修改密码："
            label-width="6.25rem"
            required
            :rules="[
              { required: true, message: '请输入新密码', trigger: 'blur' }
            ]"
            prop="passWord"
          >
            <el-input
              placeholder="请输入新密码"
              prefix-icon="el-icon-lock"
              :type="eyeFlag ? 'text' : 'password'"
              class="passwordIcon"
              v-model.trim="changePwForm.passWord"
            >
              <i
                slot="suffix"
                class="font18"
                :class="[eyeFlag ? 'el-icon-view' : 'iconfont icon-biyanjing']"
                @click="eyeFlag = !eyeFlag"
              ></i>
            </el-input>
          </el-form-item>

          <el-form-item
            label="确认密码："
            label-width="6.25rem"
            required
            :rules="[
              { required: true, message: '请确认新密码', trigger: 'blur' },
              { validator: this.validateConfirm, trigger: 'blur' }
            ]"
            prop="reconfirmPassword"
          >
            <el-input
              placeholder="请确认新密码"
              prefix-icon="el-icon-lock"
              :type="eyeFlag2 ? 'text' : 'password'"
              class="passwordIcon"
              v-model.trim="changePwForm.reconfirmPassword"
            >
              <i
                slot="suffix"
                class="font18"
                :class="[eyeFlag2 ? 'el-icon-view' : 'iconfont icon-biyanjing']"
                @click="eyeFlag2 = !eyeFlag2"
              ></i>
            </el-input>
          </el-form-item>
        </el-form>

        <!--  -->
        <span slot="footer" class="dialog-footer">
          <el-button @click="changePwColseDialog">取 消</el-button>
          <el-button type="primary" @click="changePwConfirmDialog">
            确 定
          </el-button>
        </span>
      </el-dialog>
    </div>

    <div v-else>
      <userSetting></userSetting>
    </div>
  </div>
</template>

<script>
import userSetting from '@/views/mobile/userSetting.vue'
import { getUserAll, register, update } from '@/api/home'
export default {
  components: {
    userSetting
  },
  data () {
    return {
      dialogVisible: false,
      dialogTitle: '新建用户',
      changePwDialogVisible: false,
      tableData: [],
      totalPage: 0,
      createAccountForm: {
        userName: '',
        passWord: ''
      },
      changePwForm: { userName: '', passWord: '', reconfirmPassword: '' },
      eyeFlag: false,
      eyeFlag2: false,
      pageData: {
        userName: JSON.parse(localStorage.getItem('userInfo')).userName,
        pageSize: 12,
        pageNum: 1
      }
    }
  },
  mounted () {
    this.getUserData()
  },
  methods: {
    async getUserData () {
      try {
        const res = await getUserAll(this.pageData)
        if (res.code == 0) {
          console.log('账号', res)
          this.tableData = res.data.total
          this.totalPage = res.data.data
        }
      } catch (error) {}
    },

    clickControl (row) {
      console.log('点击项id', row)
      this.$router.push({
        path: '/userManagementDetails',
        query: {
          id: row.id,
          userName: row.userName
        }
      })
    },
    handleSizeChange () {},
    handleCurrentChange (page) {
      this.pageData.pageNum = page
      this.getUserData(this.pageData)
      console.log('选择页码', page)
    },

    // 创建用户弹框
    async createAccount () {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.createAccountForm.resetFields()
      })
      // this.$router.push({
      //   path: 'budgetSheet'
      // })
    },
    handleClose () {
      this.dialogVisible = false
      this.$refs.createAccountForm.resetFields()
    },
    confirmDialog () {
      this.$refs.createAccountForm.validate(async valid => {
        if (valid) {
          this.dialogVisible = false
          try {
            const res = await register(this.createAccountForm)
            console.log('接口', res)
            if (res.code == 0) {
              this.$message({
                type: 'success',
                message: res.message
              })
            } else {
              this.$message({
                type: 'error',
                message: res.message
              })
            }
            this.getUserData()
          } catch (error) {}
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },

    colseDialog () {
      this.dialogVisible = false
      this.$refs.createAccountForm.resetFields()
    },

    // 修改密码弹框
    changePassword (row) {
      console.log('change')
      this.changePwDialogVisible = true
      this.changePwForm.userName = row.userName
      // this.dialogTitle = '修改密码'
    },
    changePwHandleClose () {
      this.changePwDialogVisible = false
      this.$refs.changePwForm.resetFields()
      this.changePwForm.userName = ''
    },
    // 密码二次确认校验
    validateConfirm (rule, value, callback) {
      const passWord = this.changePwForm.passWord
      if (value !== passWord) {
        callback(new Error('两次输入密码不一致'))
      } else {
        callback()
      }
    },
    changePwConfirmDialog () {
      this.$refs.changePwForm.validate(async valid => {
        if (valid) {
          this.changePwDialogVisible = false
          try {
            let arg = {
              userName: this.changePwForm.userName,
              passWord: this.changePwForm.passWord
            }
            const res = await update(arg)
            console.log('接口', res)
            if (res.code == 0) {
              this.$message({
                type: 'success',
                message: res.message
              })
            } else {
              this.$message({
                type: 'error',
                message: res.message
              })
            }
            this.getUserData()
          } catch (error) {}
        } else {
          console.log('error submit!!')
          return false
        }
        this.$refs.changePwForm.resetFields()
      })
    },
    changePwColseDialog () {
      this.changePwHandleClose()
    },
    changeIconState () {}
  }
}
</script>

<style lang="less" scoped>
.container {
  height: calc(100% - 70px);
  padding: 10px 16px;
  // height: calc(100vh - 90px);
  // margin: 20px;
  // background-color: #fff;

  .el-breadcrumb {
    margin: 20px;
  }
  .el-card {
    height: calc(100vh - 134px);
    p {
      margin-top: 300px;
      text-align: center;
      font-size: 26px;
      color: #f56c6c;
      font-weight: 600;
      letter-spacing: 0.5em;
    }
  }
  .el-pagination {
    margin-top: 20px;
  }

  .el-button--default {
    margin: 0 20px;
  }
}
.dialog-footer {
  .el-dialog__footer {
    text-align: center !important;
  }
  .el-button {
    font-size: 1.2em;
    padding: 0.5em;
    border-radius: 0.2em;
    margin: 0.6em;
  }
}

.el-table ::v-deep .el-table__cell {
  padding: 8px 2px;
}
.passwordIcon ::v-deep .el-input__suffix,
::v-deep .el-icon-lock {
  display: flex;
  align-items: center;
}
</style>
